import _ from 'lodash';

import Uuid from '../../../../support/Uuid';
import DecimalAmount from '../../../../support/DecimalAmount';

class ComplementoImpuestosLocalesInputPipe {
  getName() {
    return 'ImpuestosLocales';
  }

  apply(data, comprobante) {
    const { Complemento } = data;

    if (!Complemento || !Complemento.ImpuestosLocales) {
      return data;
    }

    const ImpuestosLocales = { ...Complemento.ImpuestosLocales };

    let { RetencionesLocales = [] } = ImpuestosLocales;

    RetencionesLocales = _.map(RetencionesLocales, (item) => {
      item.id = Uuid.v4();

      return item;
    });

    let { TrasladosLocales = [] } = ImpuestosLocales;

    TrasladosLocales = _.map(TrasladosLocales, (item) => {
      item.id = Uuid.v4();

      return item;
    });

    const { TotaldeRetenciones, TotaldeTraslados } = ImpuestosLocales;

    data = {
      ...data,
      Total: DecimalAmount.make(
        parseFloat(data.Total) + parseFloat(TotaldeRetenciones) - parseFloat(TotaldeTraslados)
      ).toFixed(2),
      Complemento: {
        ImpuestosLocales: {
          ...ImpuestosLocales,
          RetencionesLocales: [...RetencionesLocales],
          TrasladosLocales: [...TrasladosLocales],
        },
      },
    };

    return data;
  }
}

export default ComplementoImpuestosLocalesInputPipe;
